import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import GoBack from 'components/wise-components/GoBack';
import WiseAvatar from 'components/wise-components/WiseAvatar';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { routePaths } from 'routes/routePaths';

const ContactsTypes = () => {
  const navigate = useNavigate();
  return (
    <>
      <GoBack text="Who’s your new contact?" />

      <div className="mt-4">
        <Button
          onClick={() => navigate(routePaths.CONTACT_MYSELF)}
          className="w-100 py-3 bg-transparent text-1000 border-0 shadow-none hover-bg-primary2"
        >
          <Flex justifyContent="between" alignItems="center">
            <Flex alignItems="center">
              <WiseAvatar hideButtonIcon userName="John Smith" />
              <p className="mb-0 ms-3 fw-semi-bold">Myself</p>
            </Flex>
            <FontAwesomeIcon icon="angle-right" />
          </Flex>
        </Button>
        {/* ----- */}
        <Button
          onClick={() => navigate(routePaths.CONTACT_SOMEONE_ELSE)}
          className="w-100 py-3 bg-transparent text-1000 border-0 shadow-none hover-bg-primary2"
        >
          <Flex justifyContent="between" alignItems="center">
            <Flex alignItems="center">
              <WiseAvatar hideButtonIcon icon="users" />
              <p className="mb-0 ms-3 fw-semi-bold">Someone else</p>
            </Flex>
            <FontAwesomeIcon icon="angle-right" />
          </Flex>
        </Button>
        {/* ----- */}
        <Button
          onClick={() => navigate(routePaths.CONTACT_BUSINESS_CHARITY)}
          className="w-100 py-3 bg-transparent text-1000 border-0 shadow-none hover-bg-primary2"
        >
          <Flex justifyContent="between" alignItems="center">
            <Flex alignItems="center">
              <WiseAvatar hideButtonIcon icon="briefcase" />
              <p className="mb-0 ms-3 fw-semi-bold">Business or charity</p>
            </Flex>
            <FontAwesomeIcon icon="angle-right" />
          </Flex>
        </Button>
      </div>
    </>
  );
};

export default ContactsTypes;
